export default {
  changeLangVn (state) {
    state.lang = 'vn'
  },
  changeLangEn (state) {
    state.lang = 'en'
  },
  backToLogin (state) {
    state.isLoggedIn = false
  },
  setAuthAxios (state, axiosInstance) {
    state.authAxios = axiosInstance
  },
  initialise (state, payload) {
    Object.assign(state, payload)
  },
  cleanState (state) {
    state = null
  }
}
